// extracted by css-extract-rspack-plugin
export default {"grid":"grid-HKFrh0"};